import React from 'react'

export function drawLightningBolt(
    ctx: CanvasRenderingContext2D,
    x: number = 0,
    y: number = 0,
    size: number = 24,
    fillColor: string = '#8B5CF6'
): void {
    const scale = size / 25 // Original SVG is 25x25

    ctx.save()
    ctx.translate(x, y)
    ctx.fillStyle = fillColor

    ctx.beginPath()
    ctx.moveTo(3.15 * scale, -6.5 * scale)  // Start point (15.65-12.5, 6-12.5)
    ctx.lineTo(4.17 * scale, -5.6 * scale)  // (1.02, 0.9) relative
    ctx.lineTo(0.15 * scale, -0.67 * scale) // (-4.02, 4.93) relative
    ctx.lineTo(5.44 * scale, -0.67 * scale) // horizontal line (5.29 width)
    ctx.lineTo(-2.91 * scale, 6.5 * scale)  // diagonal to bottom left
    ctx.lineTo(-3.93 * scale, 5.6 * scale)  // (-1.02, -0.9) relative
    ctx.lineTo(0.09 * scale, 0.67 * scale)  // (4.02, -4.93) relative
    ctx.lineTo(-5.2 * scale, 0.67 * scale)  // horizontal line left
    ctx.closePath()

    ctx.fill()
    ctx.restore()
}

export const LightningBoltIcon: React.FC<{
    size?: number
    color?: string
    className?: string
}> = ({ size = 24, color = '#8B5CF6', className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 25 25"
            width={size}
            height={size}
            className={className}
        >
            <path
                fill={color}
                d="m15.65 6 1.02.9-4.02 4.93h5.29L9.59 19l-1.02-.9 4.02-4.93H7.3L15.65 6Z"
            />
        </svg>
    )
}

export default { drawLightningBolt, LightningBoltIcon }